import { FunctionComponent, HTMLAttributes } from "react";
import styles from "./dietPickerButtonGrid.module.css";

export const DietPickerButtonGrid: FunctionComponent<
  HTMLAttributes<HTMLDivElement>
> = ({ children }) => {
  return <div className={styles.dietPickerButtonGrid}>{children}</div>;
};
